import * as ActionTypes from '../actions/restaurantsWidgetsSettings/RestaurantsWidgetsSettingsTypes';
import { IAppActions } from '../types/IAppActions';
import { IRestaurantWidgetsSettingsStore } from '../types/IRestaurantWidgetsSettingsStore';

export const initState: IRestaurantWidgetsSettingsStore = {
  isLoading: false,
  settings: {
    isShowAvailableTablesCount: false,
  },
};

export default function RestaurantWidgetsSettingsReducer(state = initState, action: IAppActions): IRestaurantWidgetsSettingsStore {
  switch (action.type) {
    case ActionTypes.UPDATE_WIDGETS_SETTINGS_REQUEST: {
      return {
        isLoading: true,
        settings: {
          ...state.settings,
          ...action.payload
        },
      };
    }

    case ActionTypes.UPDATE_WIDGETS_SETTINGS_SUCCESS: {
      return {
        isLoading: false,
        settings: state.settings,
      };
    }

    case ActionTypes.UPDATE_WIDGETS_SETTINGS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case ActionTypes.GET_WIDGETS_SETTINGS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        settings: state.settings,
      };
    }

    case ActionTypes.GET_WIDGETS_SETTINGS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        settings: action.payload,
      };
    }

    case ActionTypes.GET_WIDGETS_SETTINGS_ERROR: {
      return {
        ...state,
        isLoading: false,
        settings: state.settings,
      };
    }

    default:
      return state;
  }
}
